"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var PillDropdown = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className, _b = _a.placeholder, placeholder = _b === void 0 ? "select item" : _b, disabled = _a.disabled, scrollbar = _a.scrollbar, _c = _a.variant, variant = _c === void 0 ? 'discreet' : _c, placement = _a.placement, fallbackPlacement = _a.fallbackPlacement;
    return (react_1.default.createElement(Dropdown_1.default, { options: options, value: value, onChange: onChange, className: (0, classnames_1.default)("ui-pill-dropdown", className, "ui-pill-dropdown--" + variant), placeholder: placeholder, disabled: disabled, scrollbar: scrollbar, variant: "primary", placement: placement, fallbackPlacement: fallbackPlacement }));
};
exports.default = PillDropdown;
